/*
 * This file is part of the Det Norske Teatret Nettside 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * This is the Content component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Content({ title }) {
  return (
    <span className="svg svg-square svg-content">
      <span>
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{title}</title>
          <rect
            className="a b"
            x="20.5"
            y="5.22705"
            width="15"
            height="20"
            transform="rotate(90 20.5 5.22705)"
            fill="white"
            stroke="#000"
          />
          <line
            className="a"
            x1="4"
            y1="16.2271"
            x2="12"
            y2="16.2271"
            stroke="#000"
          />
          <rect
            className="a b"
            x="4.5"
            y="9.5"
            width="4"
            height="4"
            fill="white"
            stroke="#000"
          />
          <path
            className="b"
            d="M11.5 11.7271C14.3 11.7271 15.5 14 15.5 15.7271V4.72709C15.5 0.72709 12.8333 0.72709 11 1.22709V11.7271H11.5Z"
            fill="white"
          />
          <path
            className="a"
            d="M11.5 20C12.8333 20.1108 15.5 19.1838 15.5 15.7271M15.5 15.7271C15.5 14 14.3 11.7271 11.5 11.7271H11V1.22709C12.8333 0.72709 15.5 0.72709 15.5 4.72709C15.5 8.72709 15.5 12.2704 15.5 15.7271Z"
            stroke="#000"
            strokeLinecap="round"
          />
        </svg>
      </span>
    </span>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Content.propTypes = {
  title: PropTypes.string.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Content.defaultProps = {
  title: 'Content',
};

export default Content;
